import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-395da695"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teacher-main-wrapper"
};
const _hoisted_2 = {
  style: {
    "padding": "4px 0 0",
    "margin": "0 auto",
    "width": "1200px"
  },
  class: "teacher-wrapper"
};
const _hoisted_3 = {
  class: "link-list"
};
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "english-menu"
}, "/ Recommend famous teachers", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_8 = {
  class: "teacher-list"
};
const _hoisted_9 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_CardHeader, {
    class: "teacher-header",
    link: `/teacherList.html?name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    bodyStyle: {
      background: 'none'
    }
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString($props.menu.menu_name) + " ", 1), _hoisted_5])])]),
    right: _withCtx(() => [_hoisted_6, _hoisted_7]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_8, [$data.teacherList && $data.teacherList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.teacherList, teacherData => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      teacherData: teacherData,
      key: teacherData.teacher_id,
      menu: $props.menu,
      class: "teacher-card"
    }, null, 8, ["teacherData", "menu"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_Empty, {
    type: "people"
  })]))])])]);
}